<template>
    <a-modal title="发布交易" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="35%">
        <a-form layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="propertyId" name="propertyId">
                    <a-input v-model:value="form.propertyId"/>
                </a-form-item>
                <a-form-item label="propertyType" name="propertyType">
                    <a-input v-model:value="form.propertyType"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">

                <a-col :span="24">
                    <a-form-item label="交易价格" name="price">
                        <a-input v-model:value="form.price" placeholder="请输入交易价格"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="价格类型" name="priceType">
                        <DictSelect
                            v-model:value="form.priceType"
                            :dict-name="knowledge.PRICE_TYPE"
                            placeholder="请选择"
                        />
                    </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item label="交易方式" name="tradeMode">
                        <DictSelect
                            v-model:value="form.tradeMode"
                            :dict-name="knowledge.TRADE_MODE"
                            placeholder="请选择"
                        />
                    </a-form-item>
                </a-col>


                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
    // import dataCheck from "@/utils/dataCheck";
    import {formMixin} from "@/mixins";
    import {tradeApi} from "@/api/knowledge";
    import DictSelect from "@/components/other/DictSelect";
    import {knowledge} from "@/config/variableConfig";

    export default {
        name: "AddOrEditModal",
        components: { DictSelect},

        mixins: [formMixin],
        data() {
            return {
                knowledge,
                form: {
                    propertyId: null,
                    priceType: null,
                    tradeMode: null,
                    price:null,
                    propertyType:null,
                },
                rules: {
                    propertyId: [],
                    priceType: [],
                    tradeMode: [],
                    price:[],
                    propertyType:[],
                },
                submitUrl: tradeApi.publish
            }
        },
        mounted() {
        },
        methods: {},
    }
</script>
<style scoped lang="less">
</style>
